var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: "100%",
    viewBox: "0 0 512 512",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m397 60h-36.008c-.175-33.113-27.16-60-60.314-60-5.654 0-11.273.794-16.698 2.357l-202.132 58.229c-6.443 1.856-10.763 7.715-10.834 14.243-.004.057-.014.114-.014.171v422c0 8.284 6.716 15 15 15h311c24.262 0 44-19.738 44-44v-364c0-24.262-19.738-44-44-44zm-104.712-28.815c2.726-.786 5.549-1.185 8.391-1.185 16.612 0 30.147 13.428 30.32 30h-138.74zm118.712 436.815c0 7.72-6.28 14-14 14h-296v-392h245 51c7.72 0 14 6.28 14 14z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 141c-63.411 0-115 51.589-115 115s51.589 115 115 115 115-51.589 115-115-51.589-115-115-115zm83.648 100h-34.032c-1.106-21.675-4.63-43.117-10.751-60.556 23.106 11.934 40.058 34.145 44.783 60.556zm-83.648 99.691c-2.205-1.657-7.32-7.931-12.025-23.321-3.998-13.078-6.592-29.167-7.552-46.37h39.154c-.96 17.203-3.554 33.292-7.552 46.37-4.705 15.391-9.82 21.664-12.025 23.321zm-19.577-99.691c.96-17.203 3.554-33.292 7.552-46.37 4.705-15.391 9.821-21.664 12.025-23.321 2.205 1.657 7.32 7.931 12.025 23.321 3.998 13.078 6.592 29.167 7.552 46.37zm-19.288-60.556c-6.121 17.439-9.645 38.88-10.751 60.556h-34.032c4.725-26.411 21.677-48.622 44.783-60.556zm-44.783 90.556h34.032c1.106 21.675 4.63 43.117 10.751 60.556-23.106-11.934-40.058-34.145-44.783-60.556zm122.513 60.556c6.121-17.439 9.645-38.88 10.751-60.556h34.032c-4.725 26.411-21.677 48.622-44.783 60.556z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m336 401h-160c-8.284 0-15 6.716-15 15s6.716 15 15 15h160c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.f662f0df.svg";
export { ForwardRef as ReactComponent };